import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpService } from '../http/http.service';
import { AuthService } from '../auth/auth.service';
import { TwinService } from 'src/app/services/twin/twin.service';
import { DeviceSearchResult } from '../../interfaces/device-search-result.interface';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  private sharedData: Subject<any> = new Subject<any>();
  private subject = new Subject<any>();
  private title = new Subject<any>();
  public onDevicesChangedDeploymentProfile: BehaviorSubject<DeviceSearchResult[]> = new BehaviorSubject([]);
  public onDevicesChangedDeviceSearch: BehaviorSubject<DeviceSearchResult[]> = new BehaviorSubject([]);  
  private previousUrl = new Subject<any>();
  private setDeviceDisable = new Subject<boolean>()
  private requestInProgress: Subject<any> = new Subject<any>();
  sharedData$: Observable<any> = this.sharedData.asObservable();
  requestInProgress$: Observable<any> = this.requestInProgress.asObservable();
  title$: Observable<any> = this.title.asObservable();
  previousUrl$: Observable<any> = this.previousUrl.asObservable();
  setDeviceDisable$ : Observable<boolean> = this.setDeviceDisable.asObservable();
  permissions: Array<any> = [];
  devices: any;
  hubFilterList : any;
  dbFilterList : any;
  packageId: number | null = null;
  deviceTypeId: number | null = null;

  constructor(private http: HttpService, private auth: AuthService, private twin: TwinService, private toaster: ToastrService) {
    this.auth.permissions$.subscribe(
        (permissionsList: any) => (this.permissions = permissionsList)
    );
  }
  
  setData(updatedData: boolean) {
    this.sharedData.next(updatedData);
  }
  setDataProgress(updatedData: boolean) {
    this.requestInProgress.next(updatedData);
  }
  sendClickEvent(value: string) {
    this.subject.next(value);
  }
  setTitle(value: string) {
    this.title.next(value);
  }

   setPreviousUrl(urlvalue:string) {
    this.previousUrl.next(urlvalue);
  }

  setDeviceDisabled(isDeviceDisabled: boolean) {
    this.setDeviceDisable.next(isDeviceDisabled);
  }
  
  setExistingFilters(hubFilterValue: any, dbFilterValue: any, packageId: number | null = null, deviceTypeId: number | null = null) {
    this.hubFilterList = hubFilterValue;
    this.dbFilterList = dbFilterValue;
    this.packageId = null;
    if (packageId) {
      this.packageId = packageId;
    }
    this.deviceTypeId = null;
    if (deviceTypeId) {
      this.deviceTypeId = deviceTypeId;
    }
  }
  
  getExistingFilters() {
    let hubFilter = this.hubFilterList;
    let dbFilter = this.dbFilterList;
    const packageFilter = this.packageId;
    const deviceTpeFilter = this.deviceTypeId;
    return { hubFilter, dbFilter, packageFilter, deviceTpeFilter };
  }

   hasPermission(requestedPermission: string) {
    return !!(this.permissions && this.permissions.find((permission: any) => {
            return requestedPermission == permission
    }));
  }

  onDeviceSearchClick(query:string, sqlSearchFilter:string){
    this.twin.getFilteredTwins(query, sqlSearchFilter, "Device Search").subscribe({
      next: (d: any) => {
        this.devices = d;
        this.onDevicesChangedDeviceSearch.next(d);
      },
      error: (e: any) => {
        this.toaster.error("Problem with API. Please try again later");
        this.onDevicesChangedDeviceSearch.next([]);
      }
    });
  }

  onDeploymentProfileSearchClick(query:string, sqlSearchFilter:string){
    this.twin.getFilteredTwins(query, sqlSearchFilter, "Deployment Profile Search").subscribe({
      next: (d: any) => {
        this.devices = d;
        this.onDevicesChangedDeploymentProfile.next(d);
      },
      error: (e: any) => {
        this.toaster.error("Problem with API. Please try again later");
        this.onDevicesChangedDeploymentProfile.next([]);
      }
    });
  }

  resetDevices(){
    this.onDevicesChangedDeviceSearch.next([]);
    this.onDevicesChangedDeploymentProfile.next([]);
  }

  setDisableDeviceLockValue(value: any) {
    this.devices.forEach((deviceItem: any) => {
      if (deviceItem.twin.deviceId === value.id) {
        deviceItem.twin.properties.desired.systemLock = value.twin.properties.desired.systemLock
      }
    });
    this.onDevicesChangedDeviceSearch.next(this.devices);
    this.onDevicesChangedDeploymentProfile.next(this.devices);
  }
}
